






































import Component from 'vue-class-component';
import {Vue, Watch} from 'vue-property-decorator';
import {STATIC_COMPANY_DATA} from '@/companydata';
import AmetrasResponsiveTabBar, {AmetrasResponsiveTabBarItem} from '@/views/pageskeleton/AmetrasResponsiveTabBar.vue';
import {DisguiseRoute} from '@/routetype';

interface VuetifyBreadcrumbItemType {
  href?: string;
  disabled?: boolean;
  link?: boolean;
  text: string | number;
  to?: string | object;
}

@Component({
  components: {AmetrasResponsiveTabBar}
})
export default class ToolbarTemplate extends Vue {

  company = STATIC_COMPANY_DATA;
  breadcrumbs: VuetifyBreadcrumbItemType[] = [];
  tabsInRoute: AmetrasResponsiveTabBarItem[] | undefined;
  tabIndexFromRoute: number = 0;

  @Watch('$route') onNavigate() {
    this.initializeTabs();
    this.updateNavigationPathInPageTitle();
  }

  /**
   * Updates the breadcrumb and page title details
   * O(n)
   */
  private updateNavigationPathInPageTitle() {
    const newBreadcrumbs: VuetifyBreadcrumbItemType[] = [];
    const matchedRoutes = this.$route.matched;

    const hasSubNavigation = this.$route.meta && this.$route.meta.children;

    /**
     * exception for pages with sub navigation (e.g. tab bar)
     * We should highlight the deepest active navigation item.
     * If we are in a page that has sub-navigation, we must not highlight the current page name that holds
     *  the page with the sub navigation, but the sub navigation itself.
     */
    const subNavigationBreadcrumbOffset = hasSubNavigation ? 0 : 1;

    for (let matchedRouteIndex = 0;
         matchedRouteIndex < matchedRoutes.length - subNavigationBreadcrumbOffset;
         matchedRouteIndex++) {
      const matchedRoute = matchedRoutes[matchedRouteIndex];
      newBreadcrumbs.push({
        text: matchedRoute.meta.naviText,
        to: matchedRoute.path
      });
    }
    this.breadcrumbs = newBreadcrumbs;

    this.tabIndexFromRoute = this.getCurrentActiveTabIndexFromRouter();
  }

  private getCurrentActiveTabIndexFromRouter(): number {
    let result: number = 0;
    if (this.$route.meta && this.$route.matched && this.$route.matched.length) {
      const currentRoute = this.$route.matched[this.$route.matched.length - 1].path + '/';
      for (let currentSubRouteIndex = 0;
           currentSubRouteIndex < ((this.$route.meta.children as DisguiseRoute[]) || []).length;
           currentSubRouteIndex++) {
        const currentChildRoute = this.$route.meta.children[currentSubRouteIndex];
        // all tab children
        const currentChildPath = currentChildRoute.path;
        const currentFullPath = this.$route.fullPath;
        if (currentRoute + currentChildPath === currentFullPath) {
          result = currentSubRouteIndex;
          break;
        }
      }
    }
    return result;
  }

  private changeActiveTabIndexInRouter(newTabIndex: number) {
    if (this.$route.meta && this.$route.meta.children && this.$route.meta.children[newTabIndex]) {
      const newRoutePath = this.$route.matched[this.$route.matched.length - 1].path
          + '/' +
          this.$route.meta.children[newTabIndex].path;
      if (newRoutePath === this.$route.fullPath) {
        if (this.$route.meta.children[newTabIndex].meta.reloadOnUserRequest) {
          // route is already opened. Avoid Navigation Duplicated error and force reload
          this.$store.commit('rerenderRouterView');
        }
      } else {
        this.$router.push(newRoutePath);
      }
    } else {
      throw new Error('Unexpected router behaviour.');
    }
  }

  private initializeTabs() {
    if (this.$route.meta && this.$route.meta.children) {
      const tabsInRoute: AmetrasResponsiveTabBarItem[] = [];
      for (const currentRouterTab of (this.$route.meta.children as DisguiseRoute[])) {
        tabsInRoute.push({
          text: currentRouterTab.meta?.naviText || '',
          title: currentRouterTab.meta?.naviText || ''
        });
      }
      this.tabsInRoute = tabsInRoute;
    }
  }
}
